import { render, staticRenderFns } from "./JVxeDetailsModal.vue?vue&type=template&id=5617d863"
import script from "./JVxeDetailsModal.vue?vue&type=script&lang=js"
export * from "./JVxeDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./JVxeDetailsModal.vue?vue&type=style&index=0&id=5617d863&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports